@if (routeConfigLoader && $routerLoading()) {
    <div class="fixed z-50 flex h-full w-full items-center justify-center bg-black/30 backdrop-blur-xs">
        <div class="flex flex-col items-center justify-center gap-5">
            <div class="flex flex-col text-center text-white">
                <div>Loading...</div>
            </div>
        </div>
    </div>
}

<router-outlet />
